'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var FormControl = require('../../../components/FormControl.js');
var Select = require('@narvar/nth-block-select');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var MustacheNestedRender = require('@narvar/nth-bit-mustache-nested-render');
var TextLink = require('@narvar/nth-bit-text-link');
var useFormState = require('../useFormState.js');
var nthHookSettings = require('@narvar/nth-hook-settings');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);
var MustacheNestedRender__default = /*#__PURE__*/_interopDefaultLegacy(MustacheNestedRender);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const templateLinkContext = (href, reasonValue, orderNumber, logTitan) => {
  const ALink = _ref => {
    let {
      children
    } = _ref;
    return /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
      key: href,
      linkStyle: {
        sDefault: {
          color: 'inherit',
          fontSize: 'inherit',
          lineHeight: 'inherit'
        }
      },
      href: href || '',
      onClick: () => {
        logTitan === null || logTitan === void 0 ? void 0 : logTitan({
          event: 'order_cancelled',
          properties: {
            order_id: orderNumber,
            filters: [{
              type: 'reason',
              value: reasonValue
            }],
            extra_properties: [{
              key: 'cancel_reason',
              value: 'REDIRECT_TO_URL'
            }, {
              key: 'cancel_url',
              value: href
            }]
          }
        })
        // eslint-disable-next-line no-console
        .catch(e => console.error(e));
      }
    }, children);
  };
  return ALink;
};
const ClaimReasonField = _ref2 => {
  let {
    error,
    value,
    onChange,
    orderNumber,
    logTitan,
    additionalOptions
  } = _ref2;
  const {
    claimsOrderLookupReasonRequired,
    claimsOrderLookupReasonLabel,
    claimsOrderLookupReasonOptionMissingPackage,
    claimsOrderLookupReasonOptionItemDamaged,
    claimsOrderLookupReasonOptionItemMissing,
    claimsOrderLookupReasonOptionWrongItem,
    claimsOrderLookupReasonOptionWrongItemHelperText
  } = nthHookTranslations.useTranslations();
  const {
    availableClaimTypeOptions,
    claimTypeOptionActions
  } = nthHookSettings.useSettings();
  const [reasonHelperTextShown, setReasonHelperTextShown] = React.useState(false);
  const claimTypeOptionHelperTexts = {
    ItemMissing: '',
    ItemDamaged: '',
    PackageMissing: '',
    WrongItem: claimsOrderLookupReasonOptionWrongItemHelperText || ''
  };
  const claimTypeOptionLabels = {
    PackageMissing: claimsOrderLookupReasonOptionMissingPackage || '',
    ItemDamaged: claimsOrderLookupReasonOptionItemDamaged || '',
    ItemMissing: claimsOrderLookupReasonOptionItemMissing || '',
    WrongItem: claimsOrderLookupReasonOptionWrongItem || ''
  };
  const additionalOptionLabels = (additionalOptions || []).reduce((acc, option) => ({
    ...acc,
    [option.value]: option.label
  }), {});
  const defaultClaimTypeOptions = ['PackageMissing', 'ItemDamaged', 'ItemMissing'];
  const claimTypeOptions = (availableClaimTypeOptions || defaultClaimTypeOptions).filter(claimValue => claimValue !== null && claimValue !== undefined).map(claimValue => {
    return {
      value: claimValue,
      label: claimTypeOptionLabels[claimValue] || ''
    };
  });
  const onReasonChange = value => {
    var _claimTypeOptionActio2;
    const selectedClaimTypeOption = value === null || value === void 0 ? void 0 : value.value;
    logTitan === null || logTitan === void 0 ? void 0 : logTitan({
      event: 'products_list_filtered',
      properties: {
        order_id: orderNumber,
        filters: [{
          type: 'reason',
          value: selectedClaimTypeOption ?? ''
        }],
        extra_properties: claimTypeOptions.map((option, i) => {
          var _claimTypeOptionActio;
          return [{
            key: `reason_item_${i}_value`,
            value: option.value
          }, {
            key: `reason_item_${i}_variant`,
            value: (claimTypeOptionActions === null || claimTypeOptionActions === void 0 ? void 0 : (_claimTypeOptionActio = claimTypeOptionActions[option.value]) === null || _claimTypeOptionActio === void 0 ? void 0 : _claimTypeOptionActio.actionType) ?? ''
          }];
        }).flat()
      }
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    onChange(useFormState.FieldName.claimTypeOption, selectedClaimTypeOption);
    if ((claimTypeOptionActions === null || claimTypeOptionActions === void 0 ? void 0 : (_claimTypeOptionActio2 = claimTypeOptionActions[selectedClaimTypeOption]) === null || _claimTypeOptionActio2 === void 0 ? void 0 : _claimTypeOptionActio2.actionType) === 'PREVENT_SUBMIT_SHOW_HELPER_TEXT') {
      setReasonHelperTextShown(true);
    } else {
      setReasonHelperTextShown(false);
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(FormControl["default"], {
    error: error || reasonHelperTextShown,
    helperText: error && claimsOrderLookupReasonRequired || value && reasonHelperTextShown && /*#__PURE__*/React__default["default"].createElement(MustacheNestedRender__default["default"], {
      template: mustache__default["default"].parse(claimTypeOptionHelperTexts[value] ?? ''),
      context: new mustache__default["default"].Context({
        redirectUrl: () => {
          var _claimTypeOptionActio3;
          return templateLinkContext((claimTypeOptionActions === null || claimTypeOptionActions === void 0 ? void 0 : (_claimTypeOptionActio3 = claimTypeOptionActions[value]) === null || _claimTypeOptionActio3 === void 0 ? void 0 : _claimTypeOptionActio3.redirectUrl) || '', value, orderNumber, logTitan);
        }
      })
    })
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      margin: '0 0 -1rem 0'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Select__default["default"], {
    label: claimsOrderLookupReasonLabel || '',
    options: claimTypeOptions.concat(additionalOptions ?? []),
    error: error || reasonHelperTextShown ? 'error' : undefined,
    name: "claimTypeOption",
    value: value ? {
      value,
      label: claimTypeOptionLabels[value] || additionalOptionLabels[value] || ''
    } : undefined,
    onChange: onReasonChange
  })));
};
var ClaimReasonField$1 = nthHookTranslations.withTranslationsProvider(nthHookSettings.withSettingsProvider(ClaimReasonField, {
  settingsRequested: `
    availableClaimTypeOptions
    claimTypeOptionActions {
      ItemMissing {
        actionType
        redirectUrl
      }
      ItemDamaged {
        actionType
        redirectUrl
      }
      PackageMissing {
        actionType
        redirectUrl
      }
      WrongItem {
        actionType
        redirectUrl
      }
    }
  `
}), {
  translationKeys: ['claimsOrderLookupReasonRequired', 'claimsOrderLookupReasonLabel', 'claimsOrderLookupReasonOptionMissingPackage', 'claimsOrderLookupReasonOptionItemDamaged', 'claimsOrderLookupReasonOptionItemMissing', 'claimsOrderLookupReasonOptionWrongItem', 'claimsOrderLookupReasonOptionWrongItemHelperText']
});

exports["default"] = ClaimReasonField$1;
